import axios from 'axios'

 
export default {

    async createAccount(params,callback){
        return await axios.post("/app/client/auth/register",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },


    async ifAuthorized(params,callback){
        return await axios.post("/app/client/auth/checkAuth",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },




}
 
